module.exports = __webpack_public_path__ + "img/server-05.9901303c.svg";